import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';

export const MainInfoBox = styled.div`
  background-color: ${({ theme }) => theme.palette.primary.background};
  padding: 15px 0;
  display: grid;
  grid-template-columns: 630px min-content;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  border-radius: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: unset;
    justify-content: unset;
    align-items: unset;
    border-radius: 0 0 21px 21px;
    padding: 20px 15px;
  }
`;

export const Price = styled(Typography.Numbers).attrs({ $variant: '1' })`
  font-weight: 700;
`;

export const Title = styled(Typography.Header).attrs({ $variant: '1' })`
  font-weight: 500;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 18px;
  }
`;

export const BookmarkButton = styled(Button)`
  width: 54px;
  height: 54px;
  padding: 15px;
  border-radius: 14px;
  background-color: ${({ theme }) => theme.palette.secondary.background};

  @media (hover: hover) {
    &:hover {
      & svg path {
        stroke: ${({ theme }) => theme.palette.brand.main};
      }
    }
  }
`;
